import WebFont from 'webfontloader';
import CopyController from '../controller/CopyController';
import {
  FONT_BOLD,
  FONT_BOLD_ITALIC,
  FONT_COPY,
  FONT_CSS,
  FONT_EXTRA_BOLD,
  FONT_ITALIC,
  FONT_LIGHT,
  FONT_REGULAR,
  FONT_SUBTITLE,
} from '../constants/AppConstants';
import { STATE_LOAD } from '../constants/StateConstants';
import { ScaleManagerPlugin } from 'plugins/springroll/ScaleManagerPlugin';
import * as Const from 'app/constants/AppConstants';

export default class Boot extends Phaser.State {
  init() {}

  preload() {
    // set flags for load checking
    this.fontsReady = false;
    this.loadComplete = false;

    // game assets
    this.game.load.baseURL = this.game.urls.getAssetsDirectory();
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('boot', 'assetpack.json', null, this);

    WebFont.load({
      custom: {
        families: [
          FONT_COPY,
          FONT_SUBTITLE,
          FONT_REGULAR,
          FONT_ITALIC,
          FONT_EXTRA_BOLD,
          FONT_BOLD,
          FONT_BOLD_ITALIC,
          FONT_LIGHT,
        ],
        urls: [this.game.urls.getFontsDirectory(FONT_CSS)],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });

    // register ScaleManagerPlugin
    this.game.springRollScaleManagerPlugin = this.game.plugins.add(
      new ScaleManagerPlugin(this.game, this.game.plugins, {
        width: Const.GAME_WIDTH_DEFAULT,
        height: Const.GAME_HEIGHT_DEFAULT,
        safeWidth: Const.GAME_SAFE_WIDTH,
        safeHeight: Const.GAME_SAFE_HEIGHT,
      })
    );

    // extended Phaser.Loader function to support 'spine' type in assetpack
    Phaser.Loader.prototype.processPack = function(pack) {
      const packData = pack.data[pack.key];

      if (!packData) {
        console.warn('Phaser.Loader - ' + pack.key + ': pack has data, but not for pack key');
        return;
      }

      for (let i = 0; i < packData.length; i++) {
        const file = packData[i];

        switch (file.type) {
          case 'image':
            this.image(file.key, file.url, file.overwrite);
            break;

          case 'text':
            this.text(file.key, file.url, file.overwrite);
            break;

          case 'json':
            this.json(file.key, file.url, file.overwrite);
            break;

          case 'xml':
            this.xml(file.key, file.url, file.overwrite);
            break;

          case 'script':
            this.script(file.key, file.url, file.callback, pack.callbackContext || this);
            break;

          case 'binary':
            this.binary(file.key, file.url, file.callback, pack.callbackContext || this);
            break;

          case 'spritesheet':
            this.spritesheet(
              file.key,
              file.url,
              file.frameWidth,
              file.frameHeight,
              file.frameMax,
              file.margin,
              file.spacing,
              file.skipFrames
            );
            break;

          case 'video':
            this.video(file.key, file.urls);
            break;

          case 'audio':
            this.audio(file.key, file.urls, file.autoDecode);
            break;

          case 'audiosprite':
            this.audiosprite(file.key, file.urls, file.jsonURL, file.jsonData, file.autoDecode);
            break;

          case 'tilemap':
            this.tilemap(file.key, file.url, file.data, Phaser.Tilemap[file.format]);
            break;

          case 'physics':
            this.physics(file.key, file.url, file.data, Phaser.Loader[file.format]);
            break;

          case 'bitmapFont':
            this.bitmapFont(
              file.key,
              file.textureURL,
              file.atlasURL,
              file.atlasData,
              file.xSpacing,
              file.ySpacing
            );
            break;

          case 'atlasJSONArray':
            this.atlasJSONArray(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlasJSONHash':
            this.atlasJSONHash(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlasXML':
            this.atlasXML(file.key, file.textureURL, file.atlasURL, file.atlasData);
            break;

          case 'atlas':
            this.atlas(
              file.key,
              file.textureURL,
              file.atlasURL,
              file.atlasData,
              Phaser.Loader[file.format]
            );
            break;

          case 'shader':
            this.shader(file.key, file.url, file.overwrite);
            break;

          case 'spine':
            this.spine(file.key, file.url);
            break;
        }
      }
    };

    //
    PhaserSpine.Spine.prototype.update = function() {
      // _super.update();
      this.state.update(this.game.time.elapsed / 1000);
      this.state.apply(this.skeleton);
      this.skeleton.color.a = this.worldAlpha;
      // this.skeleton.getRootBone().rotation = this.worldRotation * 180 / Math.PI;
      this.skeleton.updateWorldTransform();
    };

    // register Spine plugin
    this.game.add.plugin(PhaserSpine.SpinePlugin, {
      triangleRendering: true,
      debugRendering: false,
    });
  }

  fontsLoaded() {
    this.fontsReady = true;
  }

  create() {
    this.game.copy = new CopyController(this.game, this.game.cache.getXML('copy_xml'));
    this.game.isTouch =
      'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    this.loadComplete = true;
  }

  update() {
    this.checkLoading();
  }

  checkLoading() {
    if (this.loadComplete && this.fontsReady) {
      this.game.state.start(STATE_LOAD, true, false);
    }
  }
}
